import React from 'react';

const Expand = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    version="1.1"
  >
    <g id="surface1">
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: 'var(--PRIMARY)',
          fillOpacity: 1,
        }}
        d="M 22.679688 5.453125 L 18.304688 5.476562 C 17.867188 5.476562 17.535156 5.835938 17.535156 6.246094 C 17.535156 6.679688 17.867188 7.015625 18.304688 7.015625 L 20.785156 6.988281 L 17.792969 10.0625 C 17.484375 10.367188 17.484375 10.855469 17.792969 11.136719 C 17.945312 11.289062 18.148438 11.367188 18.328125 11.367188 C 18.507812 11.367188 18.714844 11.289062 18.867188 11.136719 L 21.914062 8.089844 L 21.886719 10.597656 C 21.886719 11.035156 22.222656 11.367188 22.65625 11.367188 C 23.066406 11.367188 23.425781 11.035156 23.425781 10.597656 L 23.449219 6.21875 L 23.449219 5.453125 Z M 22.679688 5.453125 "
      />
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: 'var(--PRIMARY)',
          fillOpacity: 1,
        }}
        d="M 23.449219 19.609375 L 23.425781 15.230469 C 23.425781 14.824219 23.066406 14.464844 22.65625 14.464844 C 22.21875 14.464844 21.886719 14.820312 21.886719 15.230469 L 21.914062 17.714844 L 18.867188 14.695312 C 18.558594 14.386719 18.074219 14.386719 17.792969 14.695312 C 17.484375 15 17.484375 15.488281 17.792969 15.769531 L 20.839844 18.816406 L 18.355469 18.789062 C 17.945312 18.789062 17.585938 19.125 17.585938 19.558594 C 17.585938 19.992188 17.917969 20.328125 18.355469 20.328125 L 23.5 20.378906 Z M 23.449219 19.609375 "
      />
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: 'var(--PRIMARY)',
          fillOpacity: 1,
        }}
        d="M 8.628906 5.992188 L 8.652344 10.367188 C 8.652344 10.777344 9.011719 11.136719 9.421875 11.136719 C 9.855469 11.136719 10.1875 10.777344 10.1875 10.367188 L 10.164062 7.886719 L 13.210938 10.929688 C 13.363281 11.085938 13.566406 11.160156 13.746094 11.160156 C 13.925781 11.160156 14.132812 11.085938 14.285156 10.929688 C 14.59375 10.625 14.59375 10.136719 14.285156 9.855469 L 11.265625 6.785156 L 13.746094 6.808594 C 14.15625 6.808594 14.515625 6.476562 14.515625 6.042969 C 14.515625 5.605469 14.183594 5.273438 13.746094 5.273438 L 8.601562 5.222656 Z M 8.628906 5.992188 "
      />
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: 'var(--PRIMARY)',
          fillOpacity: 1,
        }}
        d="M 13.671875 20.351562 C 14.105469 20.351562 14.4375 19.992188 14.4375 19.582031 C 14.4375 19.175781 14.078125 18.839844 13.671875 18.816406 L 11.1875 18.839844 L 14.207031 15.796875 C 14.515625 15.488281 14.515625 15 14.207031 14.71875 C 13.902344 14.414062 13.414062 14.414062 13.132812 14.71875 L 10.085938 17.742188 L 10.113281 15.257812 C 10.113281 14.824219 9.777344 14.488281 9.34375 14.488281 C 8.933594 14.488281 8.574219 14.824219 8.574219 15.257812 L 8.550781 19.636719 L 8.550781 20.402344 Z M 13.671875 20.351562 "
      />
    </g>
  </svg>
);

export default Expand;
